export const SUGGESTION_AXIS_LOCK_PX = 8
export const SUGGESTION_OPEN_THRESHOLD_PX = 40
export const SUGGESTION_REVEAL_WIDTH_PX = 80

export function suggestionGestureIntent(origin, point, lock = SUGGESTION_AXIS_LOCK_PX) {
  if (!origin || !point) return 'idle'
  const dx = Number(point.x) - Number(origin.x)
  const dy = Number(point.y) - Number(origin.y)
  if (![dx, dy].every(Number.isFinite)) return 'idle'
  if (Math.hypot(dx, dy) < lock) return 'tap'
  if (Math.abs(dx) > Math.abs(dy) + lock) return dx < 0 ? 'swipe-left' : 'swipe-right'
  return 'scroll'
}

export function suggestionRevealOffset(deltaX, open = false, width = SUGGESTION_REVEAL_WIDTH_PX) {
  const base = open ? -width : 0
  const next = base + Number(deltaX || 0)
  if (!(next < 0)) return 0
  return Math.max(-width, next)
}

export function suggestionShouldStayOpen(offset, width = SUGGESTION_REVEAL_WIDTH_PX, threshold = SUGGESTION_OPEN_THRESHOLD_PX) {
  return Number(offset) <= -threshold && width > 0
}
